<div
  fxLayout="row"
  class="header layout-unsecure"
  [ngClass]="{ 'header--integration': isIntegrationOn }"
  data-test-id="hdContainer"
  *ngIf="isLayoutEnabled"
>
  <div
    fxFlex="100%"
    fxLayoutAlign="start center"
    data-test-id="hdLogoContainer"
    class="logo-container"
  >
    <cigna-header-logo
      [ngClass]="{ layoutUnsecureNonSigninLogo: !isIntegrationOn }"
      [enableToggleSidNav]="true"
      [isFromLogin]="true"
      [attr.data-test-id]="'hdLogoConmponent'"
    ></cigna-header-logo>
  </div>

  <!-- Contact Us Link : not for integration portal -->
  <div
    fxFlex="28%"
    fxLayoutAlign="end center"
    class="contact-us-link"
    *ngIf="!isIntegrationOn"
  >
    <cigna-caheader-unsecure></cigna-caheader-unsecure>
  </div>
</div>

<div
  class="imp-main-section-wrapper"
  [class.imp-main-section-wrapper--integration]="isIntegrationOn"
>
  <router-outlet></router-outlet>
</div>

<cigna-cafooter-unsecure
  *ngIf="!isSiteDown && isLayoutEnabled"
></cigna-cafooter-unsecure>
